// extracted by mini-css-extract-plugin
module.exports = {"logo":"CardLogo_logo__W4kfk","badge":"CardLogo_badge__v5tG5"};